module.exports = __webpack_public_path__ + "static/media/search_icon_yellow.1ee8794f.svg";